import './Footer.css';
import { useNavigate } from 'react-router-dom';

function Footer(){
  const navigate = useNavigate();
  const handleRedirect = (direction)=>{
    let navigatewindow = window.location.pathname.substring(0,3);
    if(navigatewindow==="/"){
      navigatewindow+="pl";
      
    }
    if(navigatewindow!=="/ua"&&direction===" "){
      navigatewindow="";
      console.log(navigatewindow);
      
    }
    
    navigate(navigatewindow+"/" + direction);
  }
  if(window.location.pathname.substring(0,3)==="/pl"||window.location.pathname.substring(0,3)==="/"){
    return(
      <div className="App">
     
      <div className='footer'>
        <br/>
        <h1>Informacje</h1>
        <div className='footergrid'>
          <div className='footercell' id='footercell'>
            <img src='/logo.webp' alt='logo'/>
            <h5>Księgowość, doradztwo biznesowe, legalizacja działalności i pobytu obcokrajowców. Wspieramy przedsiębiorców w Polsce.</h5>
            <h5>Ul. Berka Joselewicza 2/1</h5>
            <h5>Kraków, 31-051</h5>
            <h5>NIP 6772390530</h5>
          </div>
          <div className='footercell' id='footercell1'>
            <h4>Firma Spółka</h4>
            <br/>
            <h5 onClick={()=>handleRedirect(" ")}>Strona Główna</h5>
            <h5 onClick={()=>handleRedirect("about")}>O nas</h5>
            <h5 onClick={()=>handleRedirect("contact")}>Kontakt</h5>
          </div>
          <div className='footercell' id='footercell2'>
            <h4>Usługi serwisowe</h4>
            <h5 onClick={()=>handleRedirect("ofert")}>Oferta</h5>
            <h5 onClick={()=>handleRedirect("price")}>Cennik</h5>
          </div>
          <div className='footercell' id='footercell3'>
            <h4>Media społecznościowe</h4>
            <h5><a href='https://www.facebook.com/people/Teletel-Busiess-Consulting/61572382951708/?mibextid=wwXIfr&rdid=5yV5XYwpDlhG7mmd&share_url=https%253A%252F%252Fwww.facebook.com%252Fshare%252F15CRRaRAG7%252F%253Fmibextid%253DwwXIfr'>Facebook</a></h5>
            <h5><a href='https://www.instagram.com/teletelbusinessconsulting/'>Instagram</a></h5>
          </div>
        </div>
      </div>
    </div>
  );
  }
  if(window.location.pathname.substring(0,3)==="/ua"){
    return(
      <div className="App">
     
      <div className='footer'>
        <br/>
        <h1>Iнформація</h1>
        <div className='footergrid'>
          <div className='footercell' id='footercell'>
            <img src='/logo.webp' alt='logo'/>
            <h5>Бухгалтерський облік, бізнес-консалтинг, легалізація діяльності та перебування іноземців. Ми підтримуємо підприємців у Польщі.</h5>
            <h5>Ul. Berka Joselewicza 2/1</h5>
            <h5>Kraków, 31-051</h5>
            <h5>NIP 6772390530</h5>
          </div>
          <div className='footercell' id='footercell1'>
            <h4>КОМПАНІЯ</h4>
            <br/>
            <h5 onClick={()=>handleRedirect(" ")}>Головна сторінка</h5>
            <h5 onClick={()=>handleRedirect("about")}>Про нас</h5>
            <h5 onClick={()=>handleRedirect("contact")}>Контакт</h5>
          </div>
          <div className='footercell' id='footercell2'>
            <h4>ПОСЛУГИ</h4>
            <h5 onClick={()=>handleRedirect("ofert")}>Оферта</h5>
            <h5 onClick={()=>handleRedirect("price")}>Цінник</h5>

          </div>
          <div className='footercell' id='footercell3'>
            <h4>СОЦІАЛЬНІ МЕДІА</h4>
            <h5><a href='https://www.facebook.com/people/Teletel-Busiess-Consulting/61572382951708/?mibextid=wwXIfr&rdid=5yV5XYwpDlhG7mmd&share_url=https%253A%252F%252Fwww.facebook.com%252Fshare%252F15CRRaRAG7%252F%253Fmibextid%253DwwXIfr'>Facebook</a></h5>
            <h5><a href='https://www.instagram.com/teletelbusinessconsulting/'>Instagram</a></h5>
          </div>
        </div>
      </div>
    </div>
  );
  }
    
}

export default Footer;